module.exports = __webpack_public_path__ + "img/w_press.2894290c.svg";